import React from "react";

import { Box, Divider as MuiDivider, LinkProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { FooterLink } from "../FooterLink";

const LEGAL_LINKS: Array<
  {
    title: string;
  } & LinkProps
> = [
  {
    title: "Contact Us",
    href: "/contact",
  },
  {
    title: "Legal",
    href: "https://www.idtdna.com/pages/support/usage-warranty-and-licenses",
  },
  {
    title: "Privacy Policy",
    href: "https://www.idtdna.com/pages/home/general-information/privacy",
  },
  {
    title: "Cookie Preferences",
    className: "ot-sdk-show-settings",
    id: "ot-sdk-btn",
  },
];

export const LegalLinks = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      className="legal-links"
    >
      {LEGAL_LINKS.map(({ title, href, ...otherProps }, index) => (
        <React.Fragment key={title}>
          <FooterLink href={href} {...otherProps}>
            {title}
          </FooterLink>
          {index < LEGAL_LINKS.length - 1 && (
            <Divider flexItem orientation="vertical" />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

const Divider = styled(MuiDivider)(({ theme }) => ({
  margin: "5px 6px",
  backgroundColor: theme.palette.secondary.light,
}));
